export var PolicyObjectTypes = /*#__PURE__*/ function(PolicyObjectTypes) {
    PolicyObjectTypes["TimeEntry"] = "TIME_ENTRY";
    PolicyObjectTypes["Project"] = "PROJECT";
    return PolicyObjectTypes;
}({});
export var PolicySubType = /*#__PURE__*/ function(PolicySubType) {
    PolicySubType["FlagForReview"] = "FLAG_FOR_REVIEW";
    PolicySubType["AutoReject"] = "AUTO_REJECT";
    PolicySubType["BlockSubmission"] = "BLOCK_SUBMISSION";
    PolicySubType["WarnAndProceed"] = "WARN_AND_PROCEED";
    return PolicySubType;
}({});
